import React, { useEffect, useState, useCallback } from 'react';
import { Button, Typography, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import * as authActions from 'app/auth/store/actions';
import * as ActionsDialog from 'app/store/actions';
import Error from 'app/fuse-layouts/shared-components/Error';
import { API_BASE_URL } from '@config';
import { startOidcLogin } from '../util/openIdConnect';
import { OPENID_PROVIDER_LABELS } from 'app/main/util/enums';

const OpenIdLoginForm = ({ setSelectedLoginForm }) => {
	const dispatch = useDispatch();
	const [selectedConfigId, setSelectedConfigId] = useState('');
	const error = useSelector(({ auth }) => auth.auth.error);
	const activeOpenIdConfigs = useSelector(({ auth }) => auth.auth.activeOidcProviders);
	const activeOpenIdProviders = activeOpenIdConfigs?.filter(provider => provider.enabled) || [];
	
	useEffect(() => {
		dispatch(authActions.getActiveOidcProviders());
	}, []);

	useEffect(() => {
	    if (activeOpenIdProviders?.length > 0 && !selectedConfigId) {
	      setSelectedConfigId(activeOpenIdProviders[0].id);
	    }
	}, [activeOpenIdProviders, selectedConfigId]);


	useEffect(() => {
		if (error?.type === 'modal') {
			dispatch(
				ActionsDialog.openDialog({
					children: (
						<Error
							message={`${error.message}...`}
							clearError={() => dispatch(authActions.clearError())}
						/>
					),
					maxWidth: 'xs',
					fullWidth: true,
					onClose: (event, reason) => {
						if (reason !== 'backdropClick') {
							dispatch(ActionsDialog.closeDialog());
						}
					}
				})
			);
		}
	}, [dispatch, error]);


	const handleLogin = useCallback(async () => {
		const config = activeOpenIdProviders.find(p => p.id === selectedConfigId);
		await startOidcLogin(config, API_BASE_URL);
	}, [activeOpenIdProviders, selectedConfigId]);


	if (!activeOpenIdProviders || activeOpenIdProviders.length === 0) {
		return (
			<div className="w-full">
				<Typography variant="h6" className="text-center md:w-full mb-48">
					No OpenID Providers Available
				</Typography>
				<Typography className="text-center mb-16">
					Contact your administrator to configure OpenID authentication.
				</Typography>
				<Button
					type="button"
					variant="outlined"
					color="secondary"
					className="w-full mx-auto mt-8"
					onClick={() => setSelectedLoginForm('local')}
				>
					Go Back
				</Button>
			</div>
		);
	}

	return (
		<div className="w-full">
			<Typography variant="h6" className="text-center md:w-full mb-48">
				Sign in with OpenID Connect
			</Typography>

			<FormControl variant="outlined" className="mb-16" fullWidth>
				<InputLabel id="openid-provider-select-label">OpenID Provider</InputLabel>
				<Select
					labelId="openid-provider-select-label"
					value={selectedConfigId}
					onChange={(e) => setSelectedConfigId(e.target.value)}
					label="OpenID Provider"
				>
					{activeOpenIdProviders.map((provider) => (
						<MenuItem key={provider.id} value={provider.id}>
							{provider.label || OPENID_PROVIDER_LABELS[provider.provider] || provider.provider}
						</MenuItem>
					))}
				</Select>
			</FormControl>

			<Button
				type="button"
				variant="contained"
				color="primary"
				className="w-full mx-auto mt-16"
				onClick={handleLogin}
				disabled={!selectedConfigId}
			>
				Sign in
			</Button>

			<Button
				type="button"
				variant="outlined"
				color="secondary"
				className="w-full mx-auto mt-8"
				onClick={() => setSelectedLoginForm('local')}
			>
				Go Back
			</Button>
		</div>
	);
};

export default OpenIdLoginForm;
